import Icon from '../components/Icon.vue'

Icon.register({
  seedling: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M64 96c123.7 0 224 100.3 224 224v144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-144c-123.7 0-224-100.3-224-224h64zM448 32h64c0 115.9-88 211.1-200.7 222.8-10.8-40.7-31.3-77.4-59-107.6 38.3-68.7 111.5-115.2 195.7-115.2z'
      }
    ]
  }
})
